import React, { useState, useEffect } from 'react';
import { FaChalkboardTeacher, FaGraduationCap, FaLaptop } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import countries from '../country/country';

const FormComponent = () => {
  const publicUrl = process.env.PUBLIC_URL + '/';
  const Url = process.env.REACT_APP_URL_DEV;
  const history = useHistory();

  const [selectedCountry, setSelectedCountry] = useState('');
  const [formations, setFormations] = useState([]);
  const [selectedFormationNom, setSelectedFormationNom] = useState('');
  const [domaines, setDomaines] = useState([]);
  const [selectedDomaine, setSelectedDomaine] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedType, setSelectedType] = useState('');

  // Récupération des domaines
  useEffect(() => {
    const fetchDomaines = async () => {
      try {
        const response = await axios.get(`${Url}/api/Domaine/all`);
        if (response.data && Array.isArray(response.data.data)) {
          setDomaines(response.data.data);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des domaines:', error);
      }
    };
    fetchDomaines();
  }, [Url]);

  // Récupération des formations selon domaine
  useEffect(() => {
    if (selectedDomaine) {
      const fetchFormations = async () => {
        try {
          const response = await axios.get(
            `${Url}/api/formation/formations/domaine/${selectedDomaine}`,
          );
          if (response.data && Array.isArray(response.data.data)) {
            setFormations(response.data.data);
          } else {
            setFormations([]);
          }
        } catch (error) {
          console.error(
            'Erreur lors de la récupération des formations:',
            error,
          );
          setFormations([]);
        }
      };
      fetchFormations();
    } else {
      setFormations([]);
    }
    // Réinitialiser la formation sélectionnée à chaque changement de domaine
    setSelectedFormationNom('');
  }, [selectedDomaine, Url]);

  // Filtrage formations selon type choisi
  const filteredFormations = formations.filter((formation) => {
    if (!selectedType) return true;
    // Comparaison insensible à la casse
    return (
      formation.type &&
      formation.type.toLowerCase() === selectedType.toLowerCase()
    );
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      domaine: selectedDomaine,
      formationNom: selectedFormationNom,
      date: selectedDate,
      type: selectedType,
      pays: selectedCountry,
    };

    try {
      const response = await axios.post(`${Url}/api/Formation/recherche`, data);
      localStorage.setItem(
        'formations',
        JSON.stringify(response.data.data || []),
      );
      localStorage.setItem('searchParams', JSON.stringify(data));
      localStorage.setItem('hasSearched', 'true');
      history.push('/RechercheResult');
    } catch (error) {
      console.error('Erreur lors de la récupération des données:', error);
      localStorage.setItem('formations', JSON.stringify([]));
      localStorage.setItem('searchParams', JSON.stringify(data));
      localStorage.setItem('hasSearched', 'true');
      history.push('/RechercheResult');
    }
  };

  return (
    <div
      className="catalogue-section"
      style={{
        backgroundImage: `url(${publicUrl}assets/img/institute/Nos-Foormation.webp)`,
      }}
    >
      <div className="form-container">
        <h2>Formation sur catalogue</h2>
        <form>
          <select
            name="domaine"
            value={selectedDomaine}
            onChange={(e) => setSelectedDomaine(e.target.value)}
          >
            <option value="">Choisissez un domaine</option>
            {domaines.map((domaine) => (
              <option key={domaine.domaineId} value={domaine.domaineId}>
                {domaine.domaineNom}
              </option>
            ))}
          </select>

          <select
            name="formation"
            value={selectedFormationNom}
            onChange={(e) => setSelectedFormationNom(e.target.value)}
          >
            <option value="">Formation associée</option>
            {filteredFormations.map((formation) => (
              <option
                key={formation.formationCode}
                value={formation.formationNom}
              >
                {formation.formationNom}
              </option>
            ))}
          </select>

          <select
            name="type"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <option value="">Type de formation</option>
            <option value="Présentiel">Présentiel</option>
            <option value="En ligne">En ligne</option>
          </select>

          <h6>Date de la formation à partir de</h6>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />

          <h6>Pays de la formation</h6>
          <select
            name="pays"
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
          >
            <option value="">Choisissez un pays</option>
            {countries.map((country, index) => (
              <option key={index} value={country}>
                {country}
              </option>
            ))}
          </select>

          <button type="button" onClick={handleSubmit}>
            RECHERCHE
          </button>
        </form>
      </div>

      <div className="info-cards">
        <div className="card">
          <FaChalkboardTeacher
            size={40}
            style={{ color: '#f9a825', marginBottom: '10px' }}
          />
          <h3>FORMATION SUR MESURE</h3>
          <h6>
            <Link to="/FormMesur">En savoir +</Link>
          </h6>
        </div>
        <div className="card">
          <FaGraduationCap
            size={40}
            style={{ color: '#f9a825', marginBottom: '10px' }}
          />
          <h3>NOS CURSUS</h3>
          <h6>
            <Link to="/CursusForm">En savoir +</Link>
          </h6>
        </div>
        <div className="card">
          <FaLaptop
            size={40}
            style={{ color: '#f9a825', marginBottom: '10px' }}
          />
          <h3>E-LEARNING</h3>
          <a href="#">En savoir +</a>
        </div>
      </div>
    </div>
  );
};

export default FormComponent;
